import script from "./UserWishlist.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWishlist.vue?vue&type=script&setup=true&lang=js"

import "./UserWishlist.vue?vue&type=style&index=0&id=bab95eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab95eda"]])

export default __exports__